"use strict";

var _regeneratorRuntime = require("/codebuild/output/src2552594638/src/corporate_sites/node_modules/@babel/runtime/regenerator/index.js");
function _slicedToArray(e, t) {
  return _arrayWithHoles(e) || _iterableToArrayLimit(e, t) || _unsupportedIterableToArray(e, t) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(e, t) {
  if (e) {
    if ("string" == typeof e) return _arrayLikeToArray(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? _arrayLikeToArray(e, t) : void 0;
  }
}
function _arrayLikeToArray(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function _iterableToArrayLimit(e, t) {
  var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
  if (null != r) {
    var n,
      a,
      o = [],
      i = !0,
      s = !1;
    try {
      for (r = r.call(e); !(i = (n = r.next()).done) && (o.push(n.value), !t || o.length !== t); i = !0);
    } catch (e) {
      s = !0, a = e;
    } finally {
      try {
        i || null == r.return || r.return();
      } finally {
        if (s) throw a;
      }
    }
    return o;
  }
}
function _arrayWithHoles(e) {
  if (Array.isArray(e)) return e;
}
function asyncGeneratorStep(e, t, r, n, a, o, i) {
  try {
    var s = e[o](i),
      u = s.value;
  } catch (e) {
    return void r(e);
  }
  s.done ? t(u) : Promise.resolve(u).then(n, a);
}
function _asyncToGenerator(e) {
  return function () {
    var t = this,
      r = arguments;
    return new Promise(function (n, a) {
      var o = e.apply(t, r);
      function i(e) {
        asyncGeneratorStep(o, n, a, i, s, "next", e);
      }
      function s(e) {
        asyncGeneratorStep(o, n, a, i, s, "throw", e);
      }
      i(void 0);
    });
  };
}
function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function _createClass(e, t, r) {
  return t && _defineProperties(e.prototype, t), r && _defineProperties(e, r), e;
}
var axios = require("axios"),
  AWS = require("aws-sdk"),
  ESTIMATOR_WHATIFS_API2_LAMBDA = "WhatIfScenarioLambdaV2",
  CriticalInput = require("./../CriticalInput.service");
AWS.config.region = "us-west-2", AWS.config.credentials = new AWS.CognitoIdentityCredentials({
  IdentityPoolId: CriticalInput.IDENTITY_POOL_ID
});
var PropertyDataHandler = function () {
  return _createClass(function e() {
    _classCallCheck(this, e);
  }, [{
    key: "getPropertyData",
    value: (a = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
      var r, n, a;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return r = new AWS.Lambda(), n = JSON.stringify(t), a = {
              FunctionName: ESTIMATOR_WHATIFS_API2_LAMBDA,
              InvocationType: "RequestResponse",
              LogType: "Tail",
              Payload: '{ "fun": "getPropertyData", "input": ' + n + "}"
            }, e.next = 6, r.invoke(a).promise();
          case 6:
            return e.abrupt("return", e.sent);
          case 7:
          case "end":
            return e.stop();
        }
      }, e);
    })), function (e) {
      return a.apply(this, arguments);
    })
  }, {
    key: "getCountyStateFromZip",
    value: (n = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
      var r;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return r = "".concat("https://api2.getmybubble.io", "/fetch1?fun=ZipCityCountyState&version=v1&dget1=").concat(t), e.abrupt("return", axios.get(r));
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    })), function (e) {
      return n.apply(this, arguments);
    })
  }, {
    key: "getAppDataLocal",
    value: (r = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
      var r, n;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return r = new AWS.Lambda(), n = {
              FunctionName: CriticalInput.ESTIMATOR_WHATIFS_API1_LAMBDA,
              InvocationType: "RequestResponse",
              LogType: "Tail",
              Payload: '{ "fun": "'.concat("getAppData", '", "parameters": { "key":"').concat(t, '"}}')
            }, e.abrupt("return", r.invoke(n).promise());
          case 5:
          case "end":
            return e.stop();
        }
      }, e);
    })), function (e) {
      return r.apply(this, arguments);
    })
  }, {
    key: "getAddressFromGoogleFieldsFor",
    value: (t = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
      var r, n;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return r = {}, e.abrupt("return", this.getAppDataLocal(t).then(function (e) {
              var t = JSON.parse(e.Payload);
              return n = t.body, console.log("getAppDataLocal:then:"), n && (console.log("getAppDataLocal:formatted_address:", n.formatted_address), r.fullAddress = n.formatted_address, r.county = n.country_sn, r.stateCode = n.administrative_area_level_1_sn, r.state = n.administrative_area_level_1_sn, r.state_code = n.administrative_area_level_1_sn, r.state_name = n.administrative_area_level_1_ln, r.street = n.route_ln, r.street_type = n.route_ln, r.city_name = n.locality_ln, r.door_number = n.street_number_ln, r.zip = n.postal_code_sn), console.log("Leaving:getAddressFromGoogleFieldsFor:", r), r;
            }).catch(function (e) {
              return e;
            }));
          case 2:
          case "end":
            return e.stop();
        }
      }, e, this);
    })), function (e) {
      return t.apply(this, arguments);
    })
  }, {
    key: "parseAddressLocalAndPatch",
    value: (e = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
      var r,
        n,
        a,
        o,
        i,
        s,
        u = arguments;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            if (r = u.length > 1 && void 0 !== u[1] ? u[1] : {}, !(n = u.length > 2 && void 0 !== u[2] ? u[2] : "DUMMY") || "DUMMY" === n) {
              e.next = 6;
              break;
            }
            return e.next = 5, this.getAddressFromGoogleFieldsFor(n);
          case 5:
            return e.abrupt("return", e.sent);
          case 6:
            if (a = require("parse-address"), t = t.replace(/  /g, " "), o = r, (i = null != t && t.length > 5 ? a.parseLocation(t) : null) && (Object.entries(i).forEach(function (e) {
              var t = _slicedToArray(e, 2),
                r = t[0],
                n = t[1];
              o[r] = n;
            }), s = t.split(" "), 3 !== Object.keys(s).length && 4 !== Object.keys(s).length || (5 === s[s.length - 1].length && (o.zip = s[s.length - 1], s.pop()), 2 === s[s.length - 1].length && (o.state = s[s.length - 1], o.stateCode = s[s.length - 1], s.pop()), o.zip && o.state && (o.city = s.join(" "), o.city === o.street && delete o.street))), null != o.number && (o.door_number = o.number, delete o.number), null != o.type && (o.street_type = o.type, delete o.type), null != o.city && (o.city_name = o.city, delete o.city), null != o.state && (o.state_name = o.state, delete o.state), null == o.zip) {
              e.next = 18;
              break;
            }
            return e.next = 18, this.getCountyStateFromZip(o.zip).then(function (e) {
              console.log("response: ", e.data);
              var t = JSON.parse(e.data.output);
              return console.log("outputJson: ", t), o.state_code = t.dput2, o.county = t.dget3, o;
            }).catch(function (e) {
              return e;
            });
          case 18:
            return e.abrupt("return", o);
          case 19:
          case "end":
            return e.stop();
        }
      }, e, this);
    })), function (t) {
      return e.apply(this, arguments);
    })
  }]);
  var e, t, r, n, a;
}();
module.exports = {
  PropertyDataHandler: PropertyDataHandler
};